module.exports = {

  // nacte data z dane cesty (zadane v index.js v hpForms)
  prepareHtmlLoad (elemId, url) {
    return function () {
      $.get(url, (data) => $(elemId).html(data));
    };
  },

  // nacte widget z komponent
  prepareWidget (elemId, widget, options) {
    return function () {
      $(elemId)[widget](options);
    };
  }

};



// WEBPACK FOOTER //
// ./src/js/homepage/helpers.js